var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { class: _vm.sectionClass }, [
    _c("div", { staticClass: "section-content" }, [
      _c("div", { staticClass: "has-text-centered" }, [
        _c("div", { staticClass: "title is-spaced is-spaced-bottom" }, [
          _vm._v(_vm._s(_vm.$t("home.title_partners"))),
        ]),
      ]),
      _vm._m(0),
      _vm._m(1),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "columns column-text-center is-vcentered columns-logos" },
      [
        _c("div", { staticClass: "column is-narrow has-text-centered" }, [
          _c("img", {
            staticStyle: { height: "56px", display: "inline-block" },
            attrs: { src: "/img/enel_logo_small.png" },
          }),
        ]),
        _c("div", { staticClass: "column is-narrow has-text-centered" }, [
          _c("img", {
            staticStyle: { height: "56px", display: "inline-block" },
            attrs: { src: "/img/vodafone_business_small.png" },
          }),
        ]),
        _c("div", { staticClass: "column is-narrow has-text-centered" }, [
          _c("img", {
            staticStyle: { height: "60px", display: "inline-block" },
            attrs: { src: "/img/fastweb_small.png" },
          }),
        ]),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "columns column-text-center is-vcentered columns-logos" },
      [
        _c("div", { staticClass: "column is-narrow has-text-centered" }, [
          _c("img", {
            staticStyle: { height: "52px", display: "inline-block" },
            attrs: { src: "/img/reale_mutua_small.png" },
          }),
        ]),
        _c("div", { staticClass: "column is-narrow has-text-centered" }, [
          _c("img", {
            staticStyle: { height: "56px", display: "inline-block" },
            attrs: { src: "/img/findomestic_logo_small.png" },
          }),
        ]),
        _c("div", { staticClass: "column is-narrow has-text-centered" }, [
          _c("img", {
            staticStyle: { height: "56px", display: "inline-block" },
            attrs: { src: "/img/jtwia_small.png" },
          }),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }